module.exports = {
    'git_sha1': '16af78c9bb60993a7694bfaf9427ccbdb9d31ed5'
};



// WEBPACK FOOTER //
// ./buildinfo.js